import { CompanyDetailAndJobGroups } from '@types';
import { useSidebarItems } from './sidebar-items';

export const filterOutSidebarItems = ({
  sidebarItems,
  company,
  allowWorkflows,
  allowCollegialLending,
  companyRoles,
}: {
  sidebarItems: ReturnType<typeof useSidebarItems>;
  company: CompanyDetailAndJobGroups | undefined;
  allowWorkflows: boolean;
  allowCollegialLending: boolean;
  companyRoles: string[] | undefined;
}) => {
  const hasCompanyRoles = !!companyRoles?.length;
  const isHqAdmin = companyRoles?.includes('HQADMIN');
  const isAdmin = companyRoles?.includes('ADMIN');
  const isAnyAdmin = isHqAdmin || isAdmin;

  const offersEmployeeWork = company?.company.offersEmployeeWork;

  // shallow copy to avoid mutating original sidebar config
  const result = sidebarItems.map((section) => ({
    ...section,
    children: [...section.children],
  }));

  const getSection = (key: string) => result.find((s) => s.key === key);

  const filterSectionChildren = (key: string, predicate: (item: { path: string }) => boolean) => {
    const section = getSection(key);
    if (section) {
      section.children = section.children.filter(predicate);
    }
  };

  // Planning section rules
  if (!offersEmployeeWork) {
    filterSectionChildren('planning', (item) => item.path !== 'management/workforce');
  }

  if (!allowCollegialLending) {
    filterSectionChildren('planning', (item) => item.path !== 'planning/collegial-lending');
  }

  // Settings section rules
  if (!hasCompanyRoles || !isAnyAdmin) {
    const settingsSection = getSection('settings');
    if (settingsSection) {
      settingsSection.children = [];
    }
  }

  // Management section rules
  if (!hasCompanyRoles || !isHqAdmin || !allowWorkflows) {
    filterSectionChildren('management', (item) => item.path !== 'management/workflows');
  }

  return result;
};
